
export const state = {
    loading: false,
    transaksi: {},
    transaksis:[],
    columns: [],
    paginate: {total:0},
    resp: {}
  }
  export const mutations = {
    LOADING: (state) => {
      state.loading = true
    },
    TRANSAKSI: (state, payload) => {
      state.transaksi = payload
      state.loading = false
    },
    LOGIN: (state, payload) => {
      state.transaksi_session = payload
      state.loading = false
    },
    SET_TRANSAKSIS: (state, payload) => {
      state.loading = false
      state.paginate = payload.pagination
      state.transaksis = payload.data
    },
    SET_COLUMNS: (state, payload) => {
      state.loading = false
      state.columns = payload
    },
    SET_RESP: (state, payload) => {
      state.loading = false
      state.resp = payload
    },
  
  }
  
  export const actions = {
    POST_TRANSAKSI: async({commit}, payload) => {
      commit("LOADING")
      return await axios({url: 'api/transaksi', data: payload, method: 'POST'})
          .then(resp => {
              if(resp.data.code == 200) {
                  commit("SET_TRANSAKSIS", resp.data.data)
              } else {
                  commit("SET_RESP", resp.data)
              }
              return resp
          })
  },
    GET_TRANSAKSIS: async({commit}, args) => {
      commit("LOADING")
        console.log('args ',args)
      var params = queryString.stringify({
        ...{
            limit: 10,
            page: args.page,
            name: null,
            sort: '-id'
        }, ...args}
      )
      return await axios({url: 'api/transaksi?' + args.params, method: 'GET'})
        .then(resp => {
          if(resp.data.status == '200 OK') {
            commit("SET_TRANSAKSIS", resp.data)
          }
          return resp
        })
    },
    GET_COLUMNS: async({commit}) => {
      commit("LOADING")
      return await axios({url: 'api/transaksi/columns' , method: 'GET'})
        .then(resp => {
          if(resp.data.status == 'success') {
            commit("SET_COLUMNS", resp.data.data)
          }
          return resp
        })
    },
    DELETE_TRANSAKSI: async({commit},cutomerId) => {
      commit("LOADING")
      return await axios({url: 'api/transaksi/'+cutomerId, method: 'DELETE'})
         .then(resp => {
              if(resp.data.code == 200) {
                      swal({
                          type: 'success',
                          title: 'Status...',
                          text: resp.data.message
                      })
                  commit("SET_RESP", resp.data)
  
        }
        return resp
      })
  
  
    },
  
  }
  
  export const getters = {
    transaksi: state => state.transaksi,
    transaksis: state => state.transaksis,
    paginate: state => state.paginate,
    isLoading: state => state.loading,
    resp: state => state.resp,
    columns: state => state.columns
  }
  
  // export default {
  //   // namespaced: true,
  //   state,
  //   getters,
  //   actions,
  //   mutations,
  //
  // }
  